import { UseQueryResult, useQuery } from "react-query";

import { useAuth } from "../../sdk/hooks/useAuth";
import { IExternalListPage, IRecipe } from "../../sdk/types";
import { recipes } from "../../sdk/utils/api";
import { RecipeStatus } from "../../utils/enums";

export interface IUseGetRecipesParameters {
    status?: RecipeStatus;
    q?: string;
}

export const useGetRecipes = (
    parameters: IUseGetRecipesParameters = {},
): UseQueryResult<IExternalListPage<IRecipe>> => {
    const auth = useAuth();

    return useQuery<IExternalListPage<IRecipe>>(
        ["recipes", parameters.status, parameters.q],
        async () => {
            if (!auth.token) {
                throw new Error(
                    "Cannot fetch recipes without authorization token.",
                );
            }

            return await recipes.Recipe.list({
                token: auth.token,
                ...parameters,
            });
        },
    );
};
